import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import { ClerkProvider, SignedIn, SignedOut, RedirectToSignIn } from '@clerk/clerk-react';
import LandingPage from './components/pages/LandingPage';
import ChatPage from './components/pages/ChatPage';
import ModelsPage from './components/pages/ModelsPage';
import { ChatProvider } from './context/ChatContext';
import './App.css';

// Get the publishable key from environment variables
const clerkPubKey = process.env.REACT_APP_CLERK_PUBLISHABLE_KEY;

// Development mode warning
if (!clerkPubKey) {
  console.warn('⚠️ Clerk publishable key missing. Running in development mode without authentication.');
  console.warn('Create .env.local with REACT_APP_CLERK_PUBLISHABLE_KEY=your_key_here');
}

// Protected Route Component
const ProtectedRoute = ({ children }) => {
  // If no Clerk key, allow access in development
  if (!clerkPubKey) {
    return children;
  }
  
  return (
    <>
      <SignedIn>
        {children}
      </SignedIn>
      <SignedOut>
        <RedirectToSignIn />
      </SignedOut>
    </>
  );
};

function App() {
  // If no Clerk key, render without ClerkProvider
  if (!clerkPubKey) {
    return (
      <ChatProvider>
        <Router>
          <div className="App">
            <Routes>
              <Route path="/chat" element={<ChatPage />} />
              <Route path="/models" element={<ModelsPage />} />
              <Route path="/" element={<LandingPage />} />
            </Routes>
          </div>
        </Router>
      </ChatProvider>
    );
  }

  return (
    <ClerkProvider publishableKey={clerkPubKey}>
      <ChatProvider>
        <Router>
          <div className="App">
            <Routes>
              <Route 
                path="/chat" 
                element={
                  <ProtectedRoute>
                    <ChatPage />
                  </ProtectedRoute>
                } 
              />
              <Route 
                path="/models" 
                element={
                  <ProtectedRoute>
                    <ModelsPage />
                  </ProtectedRoute>
                } 
              />
              <Route path="/" element={<LandingPage />} />
            </Routes>
          </div>
        </Router>
      </ChatProvider>
    </ClerkProvider>
  );
}

export default App;
